module.exports = __webpack_public_path__ + "static/02-6b930b4d9fa8b3049018335dccf73ce1.jpg";